import { Button } from 'components/Button/Button'
import { ReactComponent as QuestionSvg } from 'images/icons/questionMark.svg'
import { branding } from 'utils/branding'
import style from './RightButtons.module.css'

const ButtonQuestion = () => {
  return (
    <a href={branding.getPdfReportHref()} target="_blank" rel="noreferrer">
      <Button.Outlined className={style.buttonQuestion}>
        <QuestionSvg />
      </Button.Outlined>
    </a>
  )
}

export default ButtonQuestion
